<script setup>
    import NavigationToggle from './NavigationToggle'
    import NavigationModal from './NavigationModal'
    import {NavigationControls} from "../stores/NavigationControls"
    import {onMounted, ref, watch} from "vue";

    const navigationControls = NavigationControls(),
          menuScroll = ref(window.scrollY > 0),
          darkTheme = ref(false)

    const props = defineProps({
        menu: Object,

        logo: Object,

        logoLight: Object,

        links: Object,

        featuredtitle: {
            type: String,
            required: false,
            default: () => { return null }
        },

        featuredimage: {
            type: [String, Object],
            required: false,
            default: () => { return null }
        },

        featuredintro: {
            type: String,
            required: false,
            default: () => { return null }
        },

        featuredlink: {
            type: String,
            required: false,
            default: () => { return null }
        }

    })

    window.addEventListener('scroll', function() {
        menuScroll.value = window.scrollY > 0
    })

    onMounted(() => {
        const header = document.getElementById('banner')
        darkTheme.value = header.classList.contains('dark')
    })
</script>
<template>
    <div role="banner" class="w-full fixed z-50">
        <div class="w-full h-32 flex justify-center transition duration-500"
             :class="{
                 'bg-white drop-shadow-md' : !navigationControls.visible && menuScroll,
                 'bg-cintra-grey dark' : navigationControls.visible
             }">
            <div class="block-inner flex flex-wrap justify-between items-center py-8">
                <div class="relative z-20 h-16 w-32 sm:w-44 md:w-72">
                    <a href="/" aria-label="Return to the home page" class="group">
                        <template v-if="props.logoLight">
                            <transition name="logo">
                                <img
                                    v-show="navigationControls.visible || !navigationControls.visible && !menuScroll && darkTheme"
                                    class="w-full h-full object-contain absolute top-0 left-0"
                                    :src="props.logoLight.url"
                                    alt="The Cintra logo"
                                >
                            </transition>
                        </template>
                        <template v-if="props.logo">
                            <transition name="logo">
                                <img
                                    v-show="menuScroll && !navigationControls.visible || !navigationControls.visible && !menuScroll && !darkTheme"
                                    class="w-full h-full object-contain absolute top-0 left-0"
                                    :src="props.logo.url"
                                    alt="The Cintra logo"
                                >
                            </transition>
                        </template>
                    </a>
                </div>
                <nav :id="'navigation-primary'" class="font-heading relative z-10">
                    <navigation-toggle
                        :menu-scroll="menuScroll"
                        :dark-theme="darkTheme"
                    />
                    <navigation-modal
                        :links="props.links"
                        :menu="props.menu"
                        :featuredtitle="props.featuredtitle"
                        :featuredimage="props.featuredimage"
                        :featuredintro="props.featuredintro"
                        :featuredlink="props.featuredlink"
                    />
                </nav>
            </div>
        </div>
    </div>
</template>
<style lang="scss">
    .logo-light-enter-active,
    .logo-light-leave-active {
        @apply transition;
        @apply duration-300;
    }
    .logo-light-enter-from,
    .logo-light-enter,
    .logo-light-leave-to /* .logo-light-leave-active in <2.1.8 */ {
        @apply opacity-0;
    }
    .logo-light-enter-to {
        @apply opacity-100;
    }
</style>
